<template>
	<div class="home">
		<div v-if="isCharge" class="head_message colorred">
			已开通炫彩优选新视讯体育VIP会员，无限畅看
			<div style="height">
				<el-button type="danger" size="mini" style="float: right; margin: 8px" @click="showOrderBack = true">我要退订</el-button>
			</div>
		</div>
		<div v-else class="head_message">
			<div class="head_content">收费内容</div>
			<div class="head_content">每月10元，炫彩优选新视讯体育VIP会员专区 无限畅看</div>
		</div>
		<div style="height: 18vw"></div>
		<van-list
			v-model="loading"
			:finished="finished"
			finished-text="没有更多了"
			offset="150"
			@load="onLoad"
			>
			<div v-for="(item, index) in videoList" :key="index" @click="videoCharge(item)" :class="{ mt10: index == 0 }"
				class="video_message">
				<!-- <img v-for="res in item.coverimgPathList" class="video_message_image" :src="res" alt="视频图片" /> -->
				<img v-if="item.coverimgPathList" class="video_message_image" :src="item.coverimgPathList[0]" alt="视频图片" />
				<p class="video_message_head">{{ item.title }}</p>
				<span class="video_message_date">{{ getTime(item.releaseCreateTime) }}
				<span> {{ item.pageviews }}阅</span></span>
			</div>
		</van-list>
		<div v-if="showCharge" class="dialog">
			<div class="dialog_content">
				<div style="text-align: right">
					<span @click="showCharge = false">×</span>
				</div>
				<div style="font-size: 20px; text-align: center">
					该视频为收费内容，订购观看
				</div>
				<input v-model="orderPhone" type="number" @input="
            orderPhone = orderPhone.length > 11 ? orderPhone.slice(0, 11) : orderPhone " size="large" class="order_phone" placeholder="请输入手机号" />
				<van-radio-group v-model="buyItem" class="video_radio">
					<!-- <van-radio :name="1" style="height: 40px">单次该条点播观看<span style="padding-left: 20px; color: #ff0000">3元</span></van-radio> -->
					<van-radio :name="2" style="height: 40px">开通炫彩优选新视讯体育VIP会员<span style="padding-left: 20px; color: #ff0000">10元/月</span></van-radio>
				</van-radio-group>
				<van-button size="mini" type="danger" style="display: block; margin: 10px auto; width: 110px" round @click="orderNow">立即订购</van-button>
			</div>
		</div>
		<van-popup v-model="showOrderBack" style="padding: 20px;border-radius:10px;">
			<div style="text-align:right">×</div>
			<div style="line-height: 36px; font-size: 15px">是否确认退订？</div>
			<el-button type="primary" size="mini" @click="orderBack">确认</el-button>
			<el-button type="info" size="mini" @click="showOrderBack = false">返回</el-button>
		</van-popup>
	</div>
</template>
<script>
	import axios from "axios";
	import Cookies from 'js-cookie'
	import { 
		orderBack,  // 主动退订
		getList, // 获取新闻列表地
		checkBuy, // 判断是否付费
		getNewsDetail, // 获取新闻
	 } from '@/api/dazzleColor'
	export default {
		data() {
			return {
				isCharge: false, // 是否付费会员
				videoList: [], // 新闻列表
				showCharge: false, // 收费弹窗
				buyItem: 1, // 收费弹窗单选内容
				columnId: "3805718420663096227",
				newsItem: {}, // 选中的新闻
				orderPhone: "", // 订购手机号
				showOrderBack: false, // 退订弹窗
				loading: false, // 滚动加载
				finished: false, // 是否加载完成
				pageSize: 10 , // 每页条数
				index: 0, // 页码索引
				
			};
		},
		mounted() {
			this.init();
			document.title = "炫彩优选新视讯体育会员";
		},

		methods: {
			async onLoad() {
				let params = {
					data: {
						index: this.index,
						pageSize: this.pageSize,
						columnId: this.columnId
					}
				}
				let { data } = await getList(params)
				if (data.data.list.length < this.pageSize) {
					this.finished = true
				}
				for (let i in data.data.list) {
					this.videoList.push(data.data.list[i])
				}
				this.index += this.pageSize
				this.loading = false;
			},
			async orderBack() {
				let { data } = await orderBack(this.columnId, this.orderPhone)
				if (data.status == 0) {
					this.$toast({
						position: 'bottom',
						message: '退订成功'
					})
				} else {
					this.$toast({
						position: 'bottom',
						message: data.desc
					})
				}
				this.showOrderBack = false
				this.isCharge = false
				sessionStorage.removeItem('orderPhone')
				Cookies.remove('Admin-Token')
			},
			async init() {
				let loading = this.$loading({
					lock: true,
					text: "正在拼命加载中...",
					background: "rgba(0, 0, 0, 0.3)",
				});
				if (sessionStorage.orderPhone) {
					this.orderPhone = sessionStorage.orderPhone;
					let { data: judge } = await checkBuy(this.columnId, this.orderPhone)
					if (judge.data) {
						Cookies.set('Admin-Token', judge.data)
					}
					this.isCharge = judge.data;
				}
				loading.close();
			},
			async videoCharge(item) {
				this.releaseSourceId = item.releaseSourceId
				if (this.isCharge) {
					var formData = new FormData()
					{
						formData.append('columnId', this.columnId);
						formData.append('newId',item.releaseSourceId)
						formData.append('phone',this.orderPhone)		
					}
					let { data } = await getNewsDetail(formData)
					if (data.status == 0) {
						let params = {
							id: this.releaseSourceId,
							type: 1
						}
						this.$router.push({name: 'newsDetail', params})
					}
				} else {
					this.newsItem = item;
					this.showCharge = true;
				}
			},
			getTime(time) {
				let date = new Date(time * 1000);
				let years = date.getFullYear(),
					month = date.getMonth() + 1,
					day = date.getDate(),
					hours = date.getHours(),
					minutes = date.getMinutes();
				return `${years}-${month}-${day} ${hours}:${minutes}`;
			},
			async orderNow() {
				if (!/^1[3-9]\d{9}$/.test(this.orderPhone)) {
					return this.$toast({
						position: "bottom",
						message: "手机号错误",
					});
				}
				let formData = new FormData()
				formData.append('columnId', this.columnId)
				formData.append('newId', this.releaseSourceId)
				formData.append('phone', this.orderPhone)
				let { data: judge } = await checkBuy(this.columnId, this.orderPhone)
				if (judge.data) {
					Cookies.set('Admin-Token', judge.data)
				}
				let { data } = await getNewsDetail(formData)
				sessionStorage.setItem("orderPhone", this.orderPhone);
				if (data.status > 0) {
					if (this.buyItem == 1) {
						let {
							data
						} = await axios.post(
							`/api/app/color/buyColorOne/${this.columnId}/${this.orderPhone}`
						);
						location.href = `http://open.play.cn/api/v1/charge/epay/wf/h5_pay_gateway?${data.data}`;
					} else {
						let {
							data
						} = await axios.post(
							`/api/app/color/buyColorMonth/${this.columnId}/${this.orderPhone}`
						);
						location.href = `http://open.play.cn/api/v1/charge/epay/mp/request_h5?${data.data}`;
					}
				} else if (data.status == 0) {
					this.$dialog.alert({
					  title: '提示',
					  message: '您已经订购了炫彩互动新视讯体育VIP会员，无需重复订购',
					  theme: 'round-button',
					}).then(() => {
						this.isCharge = judge.data;
					});
				}
				this.showCharge = false;
			},
		},
	};
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0;
	}

	.video_radio {
		font-size: 12px;
	}

	.home {
		width: 100vw;
		height: 100vh;
		background-color: #eee;
	}

	.head_message {
		position: fixed;
		top: 0;
		left: 0;
		background-color: #fff;
		box-sizing: border-box;
		padding-left: 10px;
		width: 100vw;
		height: 18vw;
		z-index: 1;
	}

	.h18 {
		height: 18vw;
	}

	.colorred {
		color: red;
		padding-top: 10px;
		font-size: 14px;
	}

	.head_message .head_content {
		line-height: 30px;
		font-size: 14px;
	}

	.dialog {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.3);
	}

	.dialog_content {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 70%;
		padding: 10px;
		background-color: #fff;
		border-radius: 8px;
	}

	.order_phone {
		box-sizing: border-box;
		width: 100%;
		padding-left: 5%;
		height: 8vw;
		font-size: 14px;
		border: 1px solid #eee;
		outline: none;
		background-color: #eee;
		border-radius: 10vh;
	}

	.video_message {
		position: relative;
		height: 80px;
		padding: 10px 0;
		background-color: #fff;
		border-bottom: 1px solid #ccc;
	}

	.video_message_image {
		float: left;
		width: 26%;
		height: 18vw;
		/* margin-right: 10px; */
		border-radius: 10px;
		margin-left: 20px;
		margin-top: 8px;
	}

	.video_message_head {
		font-size: 14px;
		padding-left: 27px;
	}

	.video_message_date {
		position: absolute;
		left: calc(36% + 10px);
		bottom: 10px;
		font-size: 12px;
		color: #aaa;
	}

	.mt10 {
		margin-top: 10px;
	}
</style>
